import { useLocation } from 'react-router-dom';
export var useIsMySettings = function () {
    var pathname = useLocation().pathname;
    return pathname.includes('profile') || pathname.includes('schedule');
};
